import snakeCasePkg from 'lodash/snakeCase.js';
import {
  checkCnpj,
  checkCpf,
  formatCnpj,
  formatCpf,
} from './document-utils.js';

const snakeCase = snakeCasePkg.default || snakeCasePkg;

export function identifyCpfCnpj(cpfCnpj) {
  let value = unFormatCpfCnpj(cpfCnpj);
  if (!value) return '';
  if (value.length === 11) {
    return 'CPF';
  } else if (value.length === 14) {
    return 'CNPJ';
  }
}

export function unFormatCpfCnpj(cpfCnpj) {
  if (!cpfCnpj) return '';
  return cpfCnpj.replace(/[^0-9A-Za-z]+/g, '').toUpperCase();
}

export function unFormatPunctuation(number) {
  if (!number) return '';
  return number.replace(/[^\d]+/g, '');
}

export function onlyNumbers(value) {
  if (!value) return '';
  return value.replace(/[\D.]/g, '');
}

export function formatFaturamento(value) {
  if (!value) return '';
  return value.replace(/[^,0-9]/g, '');
}

export function onlyText(value) {
  if (!value) return '';
  return value.replace(/[0-9.,/-]/g, '');
}

export function inputVersion(value) {
  if (!value) return '';
  // eslint-disable-next-line no-useless-escape
  return value.replace(/[^\.0-9]/g, '');
}

export function inputNumber(value) {
  if (!value) return '';
  return value.replace(/\D/g, '');
}

export function inputToLowerCase(value) {
  if (!value) return '';
  return value.toLowerCase();
}

export function formatCpfCnpj(valor) {
  if (!valor) return '';
  const normalized = unFormatCpfCnpj(valor);

  if (normalized.length === 11) {
    return formatCpf(normalized);
  } else if (normalized.length === 14) {
    return formatCnpj(normalized);
  }
  return normalized;
}

export function formatCpfCnpjByCaracter(valor) {
  let s = unFormatCpfCnpj(valor);
  const breakPointsCpfCnpj = {
    4: s.replace(/(\d{3})(\d{1})/g, '$1.$2'),
    5: s.replace(/(\d{3})(\d{2})/g, '$1.$2'),
    6: s.replace(/(\d{3})(\d{3})/g, '$1.$2'),
    7: s.replace(/(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3'),
    8: s.replace(/(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3'),
    9: s.replace(/(\d{3})(\d{3})(\d{3})/g, '$1.$2.$3'),
    10: s.replace(/(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3-$4'),
    11: s.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4'),
    12: s.replace(/(\d{2})(\d{3})(\d{3})(\d{4})/g, '$1.$2.$3/$4'),
    13: s.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{1})/g, '$1.$2.$3/$4-$5'),
    14: s.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5'),
  };
  return breakPointsCpfCnpj[s.length] || s;
}

export function validaCpf(cpf) {
  return checkCpf(cpf);
}

export function validaCnpj(cnpj) {
  return checkCnpj(cnpj);
}

export function validateEmail(email) {
  // eslint-disable-next-line
  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function validePhone(phone) {
  if (!phone) return true;
  return phone.match(
    /(\(\d{2}\)\s\d{5}-\d{4})|\(\d{2}\)\s(\d{5}-\d{3}_)|\(\d{2}\)(\d{5}-\d{4})|\(\d{2}\)(\d{5}-\d{3}_)|(\(\d{2}\)\s\d{4}-\d{4})|(\d{11})|(\d{10})|(\d{9})/g
  );
}

export function formatPhone(value) {
  if (!value) return '';
  const phone = value.replace(/[^\d]+/g, '');
  if (phone.length === 10)
    return phone.replace(/(\d{2})(\d{4})(\d{4})/g, '($1) $2-$3');
  if (phone.length === 11)
    return phone.replace(/(\d{2})(\d{5})(\d{4})/g, '($1) $2-$3');
  return value;
}

export function capitalize(string) {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function capitalizeAll(string) {
  if (!string) return '';
  return snakeCase(string)
    .split('_')
    .map(s => (s.length > 2 ? capitalize(s) : s))
    .join(' ');
}

export function normalizeText(string) {
  if (!string) return '';

  let str = string
    .toLowerCase()
    .normalize('NFD')
    .replace(/([\u0300-\u036f]|[^_0-9a-zA-Z])/g, '')
    .replace(/\s/g, '_')
    .trim();

  return str;
}
